module.exports = __webpack_public_path__ + "img/fa.cfcc2d62.png";